import React from "react";
import { Modal, Button } from "react-bootstrap";
import { ExclamationTriangleFill } from "react-bootstrap-icons";

const ConfirmModal = ({
  show = false,
  onHide = () => {},
  onConfirm = () => {},
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmVariant = "danger",
  loading = false,
  ...rest
}) => {
  const handleConfirm = () => {
    onConfirm();
    if (!loading) {
      onHide();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="delete-modal-sm"
      {...rest}
    >
      <Modal.Body className="text-center p-4">
        <div className="d-flex flex-column align-items-center justify-content-center mb-2">
          <span
            style={{
              background: "#fff3cd",
              borderRadius: "50%",
              padding: 16,
              display: "inline-flex",
              marginBottom: 12,
              border: "2px solid #ffe69c",
            }}
          >
            <ExclamationTriangleFill size={38} color="#f59e42" />
          </span>
          <h5 className="fw-bold text-warning mb-2" style={{ fontSize: "1.1rem" }}>
            {title}
          </h5>
        </div>
        <div className="mb-3">
          <span className="fw-semibold">{message}</span>
        </div>
        <div className="d-flex gap-2 justify-content-center">
          <Button
            variant="secondary"
            size="sm"
            onClick={onHide}
            disabled={loading}
          >
            {cancelText}
          </Button>
          <Button
            variant={confirmVariant}
            size="sm"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Processing...
              </>
            ) : (
              confirmText
            )}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmModal;
